export function octetsToMegas(octets: number) {
  return octets / 1024 / 1024;
}

export function megasToOctets(megas: number) {
  return megas * 1024 * 1024;
}